import { render, staticRenderFns } from "./statistical-analysis-external-views-detail-table.vue?vue&type=template&id=1c851bec&scoped=true&"
import script from "./statistical-analysis-external-views-detail-table.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-external-views-detail-table.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-external-views-detail-table.scss?vue&type=style&index=0&id=1c851bec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c851bec",
  null
  
)

export default component.exports